import { toast } from "react-toastify";
import { AddAvailability, GetAvailability } from "../api/services/availability";
import { AddAvailabilityProps } from "../declarations/availability";
export function useAvailability() {
  const getAvailability = async (
    page: number,
    limit: number,
    available: boolean
  ) => {
    const response = await GetAvailability(page, limit, available);
    console.log("get availability response", response);
    const { message, status, errors } = response;
    if (status === 200) {
      message && toast["success"](message);
    } else {
      message && toast["error"](message);
    }
    return response;
  };

  const addAvailability = async (payload: AddAvailabilityProps) => {
    const response = await AddAvailability(payload);
    return response;
  };

  return { getAvailability, addAvailability };
}
